export class CatalogueHistoryService {
  public history = [];
  public CatalogueHistoryModel: any = {};
  public totalCount = 0;
  public quantityPerPage = 22;
  public currentPage = 1;
  public resource: ng.resource.IResourceClass<ng.resource.IResource<InterACT.Interfaces.Catalogues.HistoryResponse>>;

  constructor($resource: ng.resource.IResourceService) {
    this.resource = $resource(
      'api/catalogues/:catalogueId/history',
      undefined,
      {
        edit: { method: 'PATCH' }, update: { method: 'PUT' }
      });
  }

  public getList(catalogueId: string, page: number, quantityPerPage: number) {
    if (angular.isDefined(page)) {
      this.currentPage = page;
    } else {
      this.currentPage = 1;
    }
    if (angular.isDefined(quantityPerPage)) {
      this.quantityPerPage = quantityPerPage;
    }

    const options = {
      expand: false,
      page: this.currentPage,
      offset: (this.currentPage - 1) * this.quantityPerPage,
      limit: this.quantityPerPage,
      catalogueId: catalogueId
    };

    return this.resource.get(options).$promise.then((resource) => {
      this.history = resource.history;
      this.totalCount = resource.meta.totalCount;
      return resource;
    });
  }

  public list() {
    return this.history;
  }
}